document.addEventListener("DOMContentLoaded", function () {
    const loadMoreButton = document.getElementById("load-more");
    const productContainer = document.getElementById("filtered-products");
    const checkboxes = document.querySelectorAll(".filter-checkbox");
    const minSlider = document.getElementById("price-min");
    const maxSlider = document.getElementById("price-max");
    const tooltipMin = document.getElementById("tooltip-min");
    const tooltipMax = document.getElementById("tooltip-max");
    const track = document.querySelector(".slider-track");
    const noProductsMessage = document.getElementById("no-products-message");
    let currentPage = 1;
    let totalPages = parseInt(loadMoreButton?.getAttribute("data-total-pages") || 1);

    const productLimit = 3; // Adjust based on setup

    // ✅ Function to Update Cart Count
    function updateCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cartData => {
                let cartCount = document.querySelector(".cart-count");
                if (cartCount) {
                    cartCount.textContent = cartData.item_count;
                }
            })
            .catch(error => console.error("Error updating cart count:", error));
    }

    // ✅ Function to Attach "Add to Cart" Event Listeners
    function attachAddToCartEvents() {
        document.querySelectorAll(".add-to-cart-form").forEach(form => {
            if (!form.hasAttribute("data-event-attached")) {
                form.setAttribute("data-event-attached", "true");

                form.addEventListener("submit", function (event) {
                    event.preventDefault();
                    let button = this.querySelector("button");
                    let productId = this.dataset.productId;
                    let formData = { id: productId, quantity: 1 };
                    button.classList.add("loading");
                    button.disabled = true;

                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData)
                    })
                        .then(response => response.json())
                        .then(data => {
                            button.classList.remove("loading");
                            button.disabled = false;
                            updateCartCount();
                            showMessage("Item added to cart successfully!", "success");
                        })
                        .catch(error => {
                            console.error("Error adding to cart:", error);
                            showMessage("Error adding item to cart.", "error");
                            button.classList.remove("loading");
                            button.disabled = false;
                        });
                });
            }
        });
    }

    // ✅ Function to Show Message
    function showMessage(message, type) {
        let messageBox = document.createElement("div");
        messageBox.textContent = message;
        messageBox.classList.add("cart-message", type);
        document.body.appendChild(messageBox);

        setTimeout(() => {
            messageBox.remove();
        }, 3000);
    }

    // ✅ Function to Show Tooltip on Slider
    function showTooltip(slider) {
        let minValue = parseInt(minSlider.value);
        let maxValue = parseInt(maxSlider.value);
        
        let minPercent = ((minValue - minSlider.min) / (minSlider.max - minSlider.min)) * 100;
        let maxPercent = ((maxValue - maxSlider.min) / (maxSlider.max - minSlider.min)) * 100;
        track.style.background = `linear-gradient(to right, #ccc ${minPercent}%, #5E0817 ${minPercent}%, #5E0817 ${maxPercent}%, #ccc ${maxPercent}%)`;
        tooltipMin.innerText = `$${minValue}`;
        tooltipMax.innerText = `$${maxValue}`;
    
        tooltipMin.style.left = `${minPercent}%`;
        tooltipMax.style.left = `${maxPercent}%`;
    
        if (slider === minSlider) {
            tooltipMin.style.opacity = "1";
            tooltipMax.style.opacity = "0";
        } else {
            tooltipMax.style.opacity = "1";
            tooltipMin.style.opacity = "0";
        }
    
        // Hide tooltip smoothly after 1.5 seconds
        clearTimeout(slider.hideTimeout);
        slider.hideTimeout = setTimeout(() => {
            tooltipMin.style.opacity = "0";
            tooltipMax.style.opacity = "0";
        }, 1500);
    }
    
    // ✅ Attach event listeners for slider movement
    minSlider.addEventListener("input", function () {
        showTooltip(minSlider);
    });
    
    maxSlider.addEventListener("input", function () {
        showTooltip(maxSlider);
    });
    

    // ✅ Function to Apply Filters
    function applyFilters() {
        let selectedFilters = [];

        // ✅ Add Price Filters
        let minPrice = minSlider.value;
        let maxPrice = maxSlider.value;
        selectedFilters.push(`filter.v.price.gte=${minPrice}`);
        selectedFilters.push(`filter.v.price.lte=${maxPrice}`);

        // ✅ Add Checkbox Filters
        document.querySelectorAll(".filter-checkbox:checked").forEach(cb => {
            selectedFilters.push(`${cb.name}=${cb.value}`);
        });

        let queryString = selectedFilters.length > 0 ? `?${selectedFilters.join("&")}` : "";

        fetch(window.location.pathname + queryString)
            .then(response => response.text())
            .then(data => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(data, "text/html");

                // ✅ Update Filtered Products
                let newProducts = doc.querySelector("#filtered-products");
                if (newProducts && newProducts.innerHTML.trim() !== "") {
                    productContainer.innerHTML = newProducts.innerHTML;
                    if (noProductsMessage) noProductsMessage.style.display = "none";
                } else {
                    productContainer.innerHTML = "<p id='no-products-message' style='color: red; text-align: center;'>No products found</p>";
                    if (noProductsMessage) noProductsMessage.style.display = "block";
                }

                // ✅ **Update Filter Counts**
                let updatedFilters = doc.querySelectorAll(".filter-count");
                updatedFilters.forEach(updatedFilter => {
                    let filterName = updatedFilter.getAttribute("data-filter");
                    let existingFilter = document.querySelector(`.filter-count[data-filter="${filterName}"]`);
                    if (existingFilter) {
                        existingFilter.innerText = updatedFilter.innerText;
                    }
                });

                attachAddToCartEvents();
            })
            .catch(error => console.error("Error fetching filtered products:", error));
    }

    // ✅ Function to Check Load More Button Visibility
    function checkLoadMoreVisibility() {
        let selectedFilters = document.querySelectorAll(".filter-checkbox:checked").length;
        let minPrice = minSlider.value;
        let maxPrice = maxSlider.value;

        // ✅ Hide Load More Button if Any Filter is Applied
        if (selectedFilters > 0 || minPrice !== minSlider.min || maxPrice !== maxSlider.max) {
            loadMoreButton.style.display = "none";
        } else {
            loadMoreButton.style.display = "block";
        }
    }


    // ✅ Load More Button Functionality
    if (loadMoreButton) {
        loadMoreButton.addEventListener("click", function () {
            if (currentPage >= totalPages) {
                loadMoreButton.style.display = "none";
                return;
            }

            currentPage++;
            loadMoreButton.classList.add("loading");

            fetch(`${window.location.pathname}?page=${currentPage}`)
                .then(response => response.text())
                .then(data => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(data, "text/html");
                    let newProducts = doc.querySelectorAll("#filtered-products .product-item");

                    if (newProducts.length > 0) {
                        newProducts.forEach(product => {
                            productContainer.appendChild(product.cloneNode(true)); // ✅ Append only new products
                        });

                        attachAddToCartEvents(); // ✅ Ensure "Add to Cart" works for new products
                    }

                    loadMoreButton.classList.remove("loading");

                    if (currentPage >= totalPages) {
                        loadMoreButton.style.display = "none";
                    }
                })
                .catch(error => {
                    console.error("Error loading more products:", error);
                    loadMoreButton.classList.remove("loading");
                });
        });
    }
    // ✅ Attach Filtering Events to Hide "Load More"
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change", function () {
            applyFilters();
            checkLoadMoreVisibility(); // ✅ Hide Load More when filter applied
        });
    });

    // ✅ Event Listeners for Sliders
    minSlider.addEventListener("input", function () {
        showTooltip(minSlider);
        applyFilters();
        checkLoadMoreVisibility();
    });

    maxSlider.addEventListener("input", function () {
        showTooltip(maxSlider);
        applyFilters();
        checkLoadMoreVisibility();
    });
    // ✅ Attach Filtering Events
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change", applyFilters);
    });

    // ✅ Ensure Initial Slider UI is Applied
    applyFilters();

    // ✅ Observe Related Products for Dynamic Loading
    let observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length > 0) {
                attachAddToCartEvents();
            }
        });
    });

    let relatedProductsContainer = document.querySelector(".related-products");
    if (relatedProductsContainer) {
        observer.observe(relatedProductsContainer, { childList: true, subtree: true });
    }

    attachAddToCartEvents();
});
